module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IRjEuZ/tc-custom/9781646564217.jpg?1723404860192",
      "alt": "This image is the cover for the book Jumping Jack Flash"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jumping Jack Flash\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Born to a carnival mother, Jack never knew his father. His mother died when he was in his teens, leaving him to fend for himself. However, Jack is not without skills and smarts. He perfects a knife and sword act where he keeps himself safe by making the steel blades go "), _c('i', [_vm._v("exactly")]), _vm._v(" where he wants them. Getting his GED and working to educate himself while keeping up his carnival act leaves no time for a social life, but he's been too busy to miss it."), _c('br'), _c('br'), _vm._v("Doug comes from a very ordinary middle class background, but his parents sent him to college and he now has a good but boring job in IT. Although razzed about being gay back in high school, he has come to terms with his sexuality but has not found Mr. Right."), _c('br'), _c('br'), _vm._v("When a druggie loser boyfriend moves out, Doug is lonely and hurt. Looking for distraction, he goes to the carnival and it's there he sees red-headed, mercurial Jack. The man is enthralling, the opposite of everything Doug is and knows. Can two men with such widely different lives find common ground to build a bond?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Deirdre O'Dare\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0